/* eslint-disable no-underscore-dangle */
import PropTypes from 'prop-types'
import {
  ConversationalForm,
  EventDispatcher,
  FlowEvents,
} from 'conversational-form'
import React from 'react'
import { connect } from 'react-redux'
import { Modal as StrapModal } from 'reactstrap'
import { Modal } from 'antd'
import { withRouter } from 'react-router-dom'
import { setCandidateId } from '../../../redux/reducers/candidateSlice'
import { formatStep, initSteps } from '../../../services/generateForm'
import { initStepsReactivation } from '../../../services/generateFormReactivation'
import validateResponse, {
  addNextSteps,
} from '../../../services/validateResponse'
import validateResponseReactivation from '../../../services/validateResponseReactivation'
import SendToMessenger from '../SendToMessenger'
import 'bootstrap/dist/css/bootstrap.min.css'
import './ConversationalForm.css'
import VideoPlayer from '../VideoPlayer'
import PasswordModal from '../PasswordModal'
import OfferInformationsModal from '../OfferInformationsModal'
import SendByMailModal from '../SendByMailModal'
import AuthService from '../../../services/AuthService'

const Auth = new AuthService()

const mapStateToProps = (state) => ({
  candidateId: state.candidate.candidateId,
})

const mapDispatchToProps = (dispatch) => ({
  setCandidateId: (candidateId) => dispatch(setCandidateId(candidateId)),
})

class MyForm extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      offerId: props.match.params.id || props.offerId,
      conversationId: null,
      companyId: props.companyId,
      teamId: props.teamId,
      candidate: props.candidate || null,
      rawSteps: [],
      currentStepIndex: 0,
      rawIntroSteps: props.introSteps,
      candidateAuthenticated: !!props.candidate,
      formData: props.candidate
        ? {
            Prénom: props.candidate.firstname,
            Nom: props.candidate.lastname,
            Mail: props.candidate.email,
          }
        : {},
      messagesToSave: [],
      rawVariablesById: {},
      newRawVariablesById: {},
      existingConversation: null,
      modalMessenger: false,
      successCb: null,
      errorCb: null,
      modalError: false,

      hideInputWrapper: false,
      fileInput: false,

      videoPlayerModal: false,
      videoUrl: null,
      reactivationId: props.reactivationId,
      passwordModal: false,
      passwordCb: null,

      modalOfferInformations: false,
      selectedOffer: null,
      offerSuggestions: [],

      modalSendByMail: false,
    }

    this.validateResponse = validateResponse.bind(this)
    this.validateResponseReactivation = validateResponseReactivation.bind(this)

    this.dispatcher = new EventDispatcher()

    this.dispatcher.addEventListener(
      FlowEvents.FLOW_UPDATE,
      (event) => {
        const { rawSteps } = this.state
        const { tag } = event.detail

        const index = rawSteps.map((step) => step._id).indexOf(tag.id)

        const step = rawSteps[index]

        rawSteps.map((step) => {
          if (step.offers) {
            step.offers.map((e) => {
              const infosBtn = document.getElementById(`info-${e._id}`)
              if (infosBtn) {
                infosBtn.addEventListener('click', () =>
                  this.showMoreInformations(e._id),
                )
              }

              const applyBtn = document.getElementById(`apply-${e._id}`)
              if (applyBtn) {
                applyBtn.addEventListener('click', () =>
                  this.startApplicationProccess(e._id),
                )
              }
            })
          }
        })

        const sendByMailBtn = document.getElementById('send-by-mail-btn')
        if (sendByMailBtn) {
          if (sendByMailBtn.getAttribute('listener') !== 'true') {
            sendByMailBtn.addEventListener('click', () => {
              this.setState({ modalSendByMail: true })
            })
            // prevent multi function call because of duplicate event listener
            sendByMailBtn.setAttribute('listener', 'true')
          }
        }

        if (step?.type === 'show_offers') {
          return addNextSteps(this)
        }

        if (step.endChat) {
          this.cf.flowManager.stop()
        }

        const rawQuestionsSteps = rawSteps.reduce((acc, step) => {
          if (step.type !== 'text') {
            acc.push(step)
          }
          return acc
        }, [])

        const questionIndex = rawQuestionsSteps
          .map((step) => step._id)
          .indexOf(tag.id)

        if (props.chatbotType === 'offer') {
          if (questionIndex + 1 === rawQuestionsSteps.length) {
            this.cf.flowManager.stop()
            this.props.setApplicationDone(true)

            if (!this.props.preview) {
              Auth.fetch('/lambda-interaction', {
                method: 'POST',
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  triggerAfterConversation: true,
                  conversationId: this.state.conversationId,
                }),
              })
                .then((res) => {
                  if (res.scheduleUrl) {
                    this.props.setNylasScheduler(res.scheduleUrl)
                  }
                })
                .catch((err) => {
                  console.error(err)
                })
            }
          }
        } else if (props.chatbotType === 'reactivation') {
          if (questionIndex === rawQuestionsSteps.length) {
            this.cf.flowManager.stop()
            this.props.setApplicationDone(true)
          }
        }
      },
      false,
    )
  }

  async componentDidMount() {
    let rawSteps
    let existingConversation

    if (this.props.chatbotType === 'offer') {
      const res = await initSteps(this)
      rawSteps = res.rawSteps
      existingConversation = res.existingConversation
    } else if (this.props.chatbotType === 'reactivation') {
      const res = await initStepsReactivation(this)
      rawSteps = res.rawSteps
    }

    let indexFirstQuestionStep = 0
    let firstQuestionStep

    const questionSteps = rawSteps.filter((step) => step.type !== 'text')

    if (questionSteps.length > 0) {
      const idFirstQuestionStep = questionSteps[0]._id

      indexFirstQuestionStep = rawSteps
        .map((step) => step._id)
        .indexOf(idFirstQuestionStep)
    }

    firstQuestionStep = rawSteps[indexFirstQuestionStep]

    let hideInputWrapper = false
    let fileInput = false

    if (
      (firstQuestionStep.type === 'qcm' &&
        firstQuestionStep.options.length <= 8) ||
      firstQuestionStep.type === 'video' ||
      firstQuestionStep.type === 'show_offers'
    ) {
      hideInputWrapper = true
    }
    if (firstQuestionStep.type === 'attachment') {
      fileInput = true
    }

    this.cf = ConversationalForm.startTheConversation({
      options: {
        suppressLog: true,
        eventDispatcher: this.dispatcher,
        submitCallback: this.submitCallback,
        preventAutoFocus: false,
        hideUserInputOnNoneTextInput: true,
        showProgressBar: true,
        flowStepCallback: (dto, success, error) => {
          if (this.props.chatbotType === 'offer') {
            this.validateResponse(dto, success, error)
          } else if (this.props.chatbotType === 'reactivation') {
            this.validateResponseReactivation(dto, success, error)
          }
        },
        userInterfaceOptions: {
          controlElementsInAnimationDelay: 150,
          robot: {
            showThinking: true,
            robotResponseTime: 1500,
            chainedResponseTime: 500,
          },
          user: {
            showThinking: false,
            showThumb: false,
          },
        },
      },
      tags: rawSteps
        .slice(0, indexFirstQuestionStep + 1)
        .map((step) => formatStep(step, this.props.sentences)),
    })

    this.elem.appendChild(this.cf.el)

    const offerSuggestions = rawSteps
      .map((step) => step.offers || [])
      .reduce((acc, val) => acc.concat(val), []) // same as flat() method, no yet implemented on some browsers

    await this.setState({
      rawSteps,
      existingConversation,
      currentStepIndex: indexFirstQuestionStep,
      hideInputWrapper,
      fileInput,
      offerSuggestions,
    })
  }

  submitCallback = () => {
    this.setState({ hideInputWrapper: true })

    if (this.props.chatbotType === 'reactivation') {
      Auth.fetch('/lambda-interaction-reactivation', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          triggerAfterReactivation: true,
          reactivationId: this.state.reactivationId,
          candidateId: this.props.candidateId,
        }),
      })
        .then((res) => {})
        .catch((err) => {
          console.error(err)
        })
    }
  }

  showMoreInformations = (offerId) => {
    const index = this.state.offerSuggestions.map((e) => e._id).indexOf(offerId)

    if (index >= 0) {
      const selectedOffer = this.state.offerSuggestions[index]

      this.setState({
        selectedOffer,
        modalOfferInformations: true,
      })
    }
  }

  startApplicationProccess = (offerId) => {
    const preview = this.props.preview
      ? '?preview=true&source=reactivation'
      : '?source=reactivation'

    window.open(`${window.location.origin}/${offerId}${preview}`, '_blank')
  }

  toggleMessenger = (success, error) => {
    this.setState({
      modalMessenger: !this.state.modalMessenger,
      successCb: success || this.state.successCb,
      errorCb: error || this.state.errorCb,
      modalError: false,
    })
  }

  toggleError = () => {
    this.setState({
      modalError: !this.state.modalError,
      modalMessenger: false,
    })
  }

  toggleVideoPlayer = (videoUrl, success, error) => {
    this.setState({
      videoPlayerModal: !this.state.videoPlayerModal,
      videoUrl,
      successCb: success || this.state.successCb,
      errorCb: error || this.state.errorCb,
      ...(!this.state.videoPlayerModal && { hideInputWrapper: true }),
    })
  }

  triggerSuccess = () => {
    addNextSteps(this)
    this.state.successCb()
  }

  createPassword = async (cb) => {
    this.setState({
      passwordModal: true,
      passwordCb: cb,
    })
  }

  render() {
    const { hideInputWrapper, fileInput } = this.state
    const { style } = this.props

    const cssStyle = {
      '--chat-response-robot-background-color': 'transparent',
      '--chat-response-robot-border-color': 'transparent',
      '--chat-response-robot-color': `${style.tertiaryColor}`,
      '--chat-response-user-background-color': `${style.secondaryColor}`,
      '--chat-response-user-border-color': `${style.secondaryColor}`,
      '--chat-response-user-color': 'white',
      '--chat-input-button-color': `${style.secondaryColor}`,
      '--chat-button-color': `${style.primaryColor}`,
      '--chat-button-highlight-color': `${style.secondaryColor}`,
      '--chat-button-background-color': `${style.secondaryColor}`,
      '--chat-input-primary-color': 'transparent',
      '--chat-input-secondary-color': `${style.secondaryColor}`,
      '--chat-input-tertiary-color': `${style.tertiaryColor}`,
      '--chat-input-hover-color': `${style.primaryColor}`,
    }

    const inputWrapperClass = hideInputWrapper
      ? 'input-wrapper-hidden'
      : 'input-wrapper-visible'
    const inputTypeClass = fileInput ? 'input-file' : 'input-classic'

    return (
      <>
        <div style={cssStyle}>
          <div
            className={`${inputWrapperClass} ${inputTypeClass}`}
            ref={(ref) => (this.elem = ref)}
          />
        </div>
        <StrapModal
          isOpen={this.state.videoPlayerModal}
          toggle={() => {
            this.toggleVideoPlayer()
            this.triggerSuccess()
          }}
          contentClassName="video-player"
        >
          <VideoPlayer
            url={this.state.videoUrl}
            toggle={() => {
              this.toggleVideoPlayer()
              this.triggerSuccess()
            }}
          />
        </StrapModal>
        <Modal
          visible={this.state.modalMessenger}
          onCancel={this.toggleMessenger}
          footer={null}
          closable={false}
        >
          Cliquez sur le bouton ci dessous afin de nous permettre de vous
          recontacter ultérieurement pour vous tenir au courant de l'évolution
          de votre candidature.
          <div className="sendtomessenger-btn">
            <SendToMessenger
              messengerAppId={this.props.messengerAppId}
              messengerPageId={this.props.messengerPageId}
              candidateId={this.props.candidateId}
              success={this.triggerSuccess}
              error={this.state.errorCb}
              toggle={this.toggleMessenger}
              isOpen={this.state.modalMessenger}
            />
          </div>
        </Modal>
        <Modal
          visible={this.state.modalError}
          toggle={this.toggleError}
          footer={null}
        >
          L'enregistrement du fichier a échoué, vérifiez qu'il est bien au
          format pdf, word ou image et que sa taille ne dépasse pas les 5 Mo. Si
          le problème persiste, merci de contacter le support à support@hollo.io
        </Modal>
        <PasswordModal
          isOpen={this.state.passwordModal}
          toggle={() =>
            this.setState({
              passwordModal: !this.state.passwordModal,
            })
          }
          callback={this.state.passwordCb}
        />

        {this.state.rawSteps.map((step) => {
          if (step.type === 'qcm' && step.options.length > 8) {
            const { options } = step

            return (
              <datalist id={step._id}>
                {options.map((option) => (
                  <option value={option.label} />
                ))}
              </datalist>
            )
          }
        })}
        {this.state.modalOfferInformations && (
          <OfferInformationsModal
            isOpen={this.state.modalOfferInformations}
            toggle={() => this.setState({ modalOfferInformations: false })}
            apply={() => {
              this.setState({ modalOfferInformations: false })
              this.startApplicationProccess(this.state.selectedOffer?._id)
            }}
            offer={this.state.selectedOffer}
            primaryColor={style.primaryColor}
          />
        )}
        {this.state.modalSendByMail && (
          <SendByMailModal
            isOpen={this.state.modalSendByMail}
            toggle={() => this.setState({ modalSendByMail: false })}
            email={this.state.candidate?.email}
            color={style.secondaryColor}
          />
        )}
      </>
    )
  }
}

MyForm.propTypes = {
  candidateId: PropTypes.string,
  className: PropTypes.string,
  companyId: PropTypes.string.isRequired,
  introSteps: PropTypes.any,
  match: PropTypes.any,
  messengerAppId: PropTypes.string.isRequired,
  messengerPageId: PropTypes.string.isRequired,
  sentences: PropTypes.object.isRequired,
  style: PropTypes.shape({}),
  teamId: PropTypes.string.isRequired,
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MyForm))
